const INITIAL_STATE = {
    toggleFriends: false,
    toggleMoreChat: false,
    showNewChat: false,
    activeUserChat: [],
    count: 0
};

const chat = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "CHAT_LIST":
            return {...state, [action.key]: action.value};
        case "CHAT_ADD_OWNER":
            let activeUserChat = state.activeUserChat;
            let newActiveUserChat = activeUserChat.filter(item => action.currentRoom._id && item._id.toString() === action.currentRoom._id.toString());
            if (!newActiveUserChat.length) {
                activeUserChat.unshift(action.currentRoom);
            }
            return {
                ...state,
                activeUserChat,
                count: activeUserChat.length,
                toggleMoreChat: activeUserChat.length < 3,
                showNewChat: false
            };
        case "CHAT_UPDATE_LIST":
            return {
                ...state,
                activeUserChat: action.rooms,
            };
        // return state;
        case "CHAT_REMOVE_OWNER":
            if (action.currentRoom) {
                let removeActiveUserChat = state.activeUserChat;
                let newRemoveActiveUserChat = removeActiveUserChat.filter(item => item._id.toString() !== action.currentRoom._id.toString());
                return {...state, activeUserChat: newRemoveActiveUserChat, count: newRemoveActiveUserChat.length};
            } else {
                return {...state, showNewChat: false};
            }
        case "CHAT_SWITCH_OWNER":
            let switchActiveUserChat = state.activeUserChat;
            let newSwitchActiveUserChat = switchActiveUserChat.filter(item => item._id.toString() !== action.currentRoom._id.toString());
            newSwitchActiveUserChat.unshift(action.currentRoom);
            return {...state, activeUserChat: newSwitchActiveUserChat};
        default:
            return state;
    }
};

export default chat;